import template from './post.html';
import controller from './post.controller';
import './post.scss';

const postComponent = {
  bindings: {},
  template,
  controller,
};

export default postComponent;



// WEBPACK FOOTER //
// ./client/app/components/post/post.component.js